import { render, staticRenderFns } from "./SavedBilling.vue?vue&type=template&id=3f2ed573&"
import script from "./SavedBilling.vue?vue&type=script&lang=ts&"
export * from "./SavedBilling.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports